import { render, staticRenderFns } from "./DirectorDeck3D.vue?vue&type=template&id=2787964c&scoped=true"
import script from "./DirectorDeck3D.vue?vue&type=script&lang=js"
export * from "./DirectorDeck3D.vue?vue&type=script&lang=js"
import style0 from "./DirectorDeck3D.vue?vue&type=style&index=0&id=2787964c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2787964c",
  null
  
)

export default component.exports